/**
 * Created by Kamil.Adamuszek on 2016-03-23.
 * Object provide libraries : lodash _ and jquery $
 * All jquery plugins should be here added (like qtip2 used in infohint component, jquery.inputmask used in text input component
 */
import $ from 'jquery';
import lodash from 'lodash';
import 'jquery.inputmask';
import './polyfills/custom-event';
import './polyfills/html5-dataset';
import './vendors/jquery.binarytransport';
import 'jquery-validation';
import noUiSlider from './vendors/nouislider';
/**
 *
 * @desc Object provides libraries : lodash _, jquery $
 * @type {{$: (jQuery|HTMLElement), _: {Lodash}, resultDataFlat: {component_text: 'text'}, currentEntity: {commonURLs: {dataUrlBase: "localhost/"}}, currentProductId: (string | number), layoutTexts: {label_text: 'text'}, location: 'body' | 'popup' | ''}
 */
export var toolbox = {
    $: $,
    _: lodash,
    noUiSlider: noUiSlider,
    resultDataFlat: {},
    currentEntity: null,
    currentProductId: null,
    layoutTexts: {},
    location: '',
};
